import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appLongTextTooltip]',
})
export class LongTextTooltipDirective implements AfterViewInit {
  constructor(private readonly _elementRef: ElementRef) {}
  ngAfterViewInit(): void {
    const element = this._elementRef.nativeElement;
    if (element.offsetWidth < element.scrollWidth) {
      const title = element.innerHTML.replaceAll('&lt;', '<').replaceAll('&gt;', '>');
      element.title = title;
    }
  }
}
